import { usePathname } from 'next/navigation';
import { ICallToActionSectionEntry } from '../../../../contentful/types/ICallToActionSectionEntry';
import CallToAction from '../../../../components/common/call-to-action/CallToAction';
import { useCommonData } from '../../../../common-data/useCommonData';
import { getLinkItemsForEntries } from '../../domain/use-cases/getLinkItemsForEntries';
import { Section } from './Section';
import { ICallToActionLink } from '../../../../ui';
import { ICallToActionTheme } from '../../../../components/common/call-to-action/ICallToActionTheme';
import { getMobileOperatingSystem } from '../../../../utils/getMobileOperatingSystem';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';
import { getIsWifiCta } from '../../domain/use-cases/getIsWifiCta';

export interface ICallToActionsSectionProps {
	id: string;
	section: ICallToActionSectionEntry;
}

export function CallToActionSection({
	id,
	section,
}: ICallToActionsSectionProps) {
	const { pathToPageIdMap } = useCommonData();
	const pathname = usePathname();
	const OS = getMobileOperatingSystem();
	const links = getLinkItemsForEntries<ICallToActionLink>(
		section.fields.links,
		pathToPageIdMap,
	);
	const theme = section.fields.theme.toLowerCase() as ICallToActionTheme;

	// On the wifi pages and Android devices only, we need to display a CTA to close window and use internet. The OS can only be determined on the client, which is why we need to filter out the CTA here
	const isWifiPage =
		pathname === `/${PageRoutes.IAHWifi}/` ||
		pathname === `/${PageRoutes.HOUWifi}/`;

	const isWifiCta = isWifiPage && getIsWifiCta(links);

	const removeCta = OS !== 'Android' && isWifiPage && isWifiCta;

	if (removeCta) return null;

	return (
		<Section id={id}>
			<CallToAction
				title={section.fields.title}
				body={section.fields.description}
				links={links}
				ctaTheme={theme}
			/>
		</Section>
	);
}
